import i18next, { t, loadNamespaces, TOptions } from 'i18next';

/**
 * This util method returns a promise of the i18next translations
 * This method can be used in places where the useTranslation hook can't be used
 * For, example if you are trying to access a translation in a saga.
 *
 * A mock for this util method, for use in unit tests, can be found at utils/mocks/translations
 */
export const getTranslations =
  (namespace: string) =>
  (path: string, options?: TOptions | string): Promise<string> =>
    loadNamespaces(namespace).then(() => t(`${namespace}:${path}`, options));

export const getTranslationBundle = (namespace: string) => (): Promise<Record<string, any>> =>
  loadNamespaces(namespace).then(() => i18next.getResourceBundle(i18next?.language, namespace));

export const getCommonTranslations = getTranslations('common');

export const getMetricTranslations = getTranslations('metrics');

export const getMetricTranslationBundle = getTranslationBundle('metrics');
